// import node module libraries
import React from 'react';
import { Outlet } from 'react-router';

const BlankLayout = (props) => {
	return (
		<>
			{props.children}
			<Outlet />
		</>
	);
};

export default BlankLayout;
